<script lang="ts">
	import { onMount } from 'svelte';
	import {
		getConsentStatusFromStorage,
		updateConsents,
		type ConsentPreferences
	} from './consentManagerUtils';

	let initialConsentStatus: ConsentPreferences | undefined = $state();

	onMount(() => {
		initialConsentStatus = getConsentStatusFromStorage();
		console.log(initialConsentStatus);
	});
</script>

<h1 class="page-title">Cookie Preferences</h1>

<div class="mx-auto max-w-prose">
	<section class="prose">
		<p>Cookies are files saved on your phone, tablet or computer when you visit a website.</p>
		<p>
			This website uses cookies to collect and store information about how you use the
			samgreening.com website, such as the pages you visit. This page has a brief explanation of
			each type of cookie we use.
		</p>
	</section>

	<div class="py-8">
		<fieldset>
			<legend class="text-xl">Analytics Preferences</legend>
			<p class="text-sm">
				We use Google Analytics cookies to measure website performance and the way that the site is
				used.
			</p>
			<div class="py-2">
				<div class="">
					<input
						id="acceptAnalytics"
						name="analyticsCookiePreference"
						type="radio"
						class=""
						checked={initialConsentStatus?.analyticsAllowed === true}
						onclick={() => {
							updateConsents({ analyticsAllowed: true });
						}}
					/>
					<label for="acceptAnalytics" class="">Accept analytics cookies</label>
				</div>
				<div class="">
					<input
						id="rejectAnalytics"
						name="analyticsCookiePreference"
						type="radio"
						class=""
						checked={initialConsentStatus?.analyticsAllowed === false}
						onclick={() => {
							updateConsents({ analyticsAllowed: false });
						}}
					/>
					<label for="rejectAnalytics" class="">Reject analytics cookies</label>
				</div>
			</div>
		</fieldset>
	</div>
</div>
